<i18n src="@/locales/views/agro_exporter/production/basic_container_export/show_process.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <div>
    <go-back-link :text="$t('labels.go_back_link')" name="ae_production_basic_container_export_list_processes_path"
      :params="{ agro_exporter_id: this.agro_exporter_id }">
    </go-back-link>

    <bread-crumbs :labels="[module_name, agro_exporter_process?.name]" />

    <template v-if="load_general_data">
      <tabs-container v-model="option_tabs" :with_routing="true" />

      <router-view :exportations="exportations" :containers="containers" :schedule="schedule"
        :agro_exporter_process="agro_exporter_process" :stats-exportations="stats_exportations"
        :stats-containers="stats_containers" v-model:current-page="current_page" :rows-per-page="rows_per_page"
        @update-schedule="updateSchedule" v-if="load_tabs"></router-view>
      <loading-message v-else />
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/production/basic_container_export/show_process.js";
import BasicContainerExportQRequester from "@/views/agro_exporter/requesters/production/basic_container_export/query.js";

export default {
  name: "AEProductionBasicContainerExportShowProcess",
  props: ["agro_exporter_process_id", "agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      load_exportations: false,
      load_containers: false,
      load_tabs: false,
      agro_exporter_process: {},
      containers: [],
      exportations: [],
      schedule: {},
      option_tabs: [],
      current_page: { exportations: 1, containers: 1 },
      rows_per_page: { exportations: 12, containers: 12 },
      stats_exportations: { total: 0, by_status: {} },
      stats_containers: { total: 0, by_status: {} },
    };
  },
  computed: {
    manage_any_ae_process_intermediated: function () {
      return this.agro_exporter_process?.manage_any_ae_process_intermediated;
    }
  },
  methods: {
    fetchData: async function () {
      this.fillOptions();
      await this.fetchAgroExporterProcess();
      this.loadData()
    },
    loadData: async function () {
      if (this.option_tabs[0].route.name === this.$route.name && !this.load_exportations) {
        await this.fetchExportations();
        this.load_exportations = true;
      } else if (this.option_tabs[1].route.name === this.$route.name && !this.load_containers) {
        await this.fetchContainers();
        this.load_containers = true;
      } else if (this.option_tabs[2].route.name === this.$route.name) {
        // await this.fetchSchedule();
      }
      this.load_general_data = true;
    },
    fetchAgroExporterProcess: async function () {
      let response =
        await BasicContainerExportQRequester.fetchAgroExporterProcess(
          this.agro_exporter_process_id
        );
      this.agro_exporter_process = response.data;
    },
    fetchContainers: async function () {
      this.load_tabs = false;
      let response = await Requester.fetchContainers({
        agro_exporter_process_id: this.agro_exporter_process_id,
        current_page: this.current_page.containers,
        rows_per_page: this.rows_per_page.containers
      });
      this.containers = response.data.containers;
      this.stats_containers = response.data.stats;
      this.load_tabs = true;
    },
    fetchExportations: async function () {
      this.load_tabs = false;
      let response = await Requester.fetchExportations({
        agro_exporter_process_id: this.agro_exporter_process_id,
        current_page: this.current_page.exportations,
        rows_per_page: this.rows_per_page.exportations
      });
      this.exportations = response.data.exportations;
      this.stats_exportations = response.data.stats;
      this.load_tabs = true;
    },
    fetchSchedule: async function ({ reference_month }) {
      if (!reference_month.year && !reference_month.month) return;

      let response = await Requester.fetchSchedule({
        agro_exporter_process_id: this.agro_exporter_process_id,
        year: reference_month.year,
        month: reference_month.month
      });

      this.schedule[reference_month.year] = this.schedule[reference_month.year] || {};
      this.schedule[reference_month.year][reference_month.month] = this.schedule[reference_month.year][reference_month.month] || {};
      this.schedule[reference_month.year][reference_month.month].containers = response.data.containers;
      this.schedule[reference_month.year][reference_month.month].exportations = response.data.exportations;

      for (let s = 0; s < reference_month.sides?.length || 0; s++) {
        const side = reference_month.sides[s];
        await this.fetchSchedule({ reference_month: side });
      }
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.exportations_title"),
          icon: "fa-solid fa-ship",
          route: { name: this.routeName("show_process_exportations") },
        },
        {
          name: this.$t("labels.containers_title"),
          icon: "fa-solid fa-truck-container",
          route: { name: this.routeName("show_process_containers") },
        },
        {
          name: this.$t("labels.schedule_title"),
          icon: "fa-solid fa-calendar-days",
          route: { name: this.routeName("show_process_schedule") },
        },
      ];
    },
    updateSchedule: async function (reference_month) {
      await this.fetchSchedule({ reference_month });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => {
        this.fillOptions();
        this.fetchAgroExporterProcess();
        this.loadData();
      })
    );
  },
  watch: {
    $route: function () {
      this.loadData();
    },
    'current_page.exportations': function () {
      this.fetchExportations();
    },
    'current_page.containers': function () {
      this.fetchContainers();
    },
  },
};
</script>
